<div class="col-12 nex-steps-3" [ngClass]="{'nex-steps-4': hasSignature, 'nex-steps-3': !hasSignature}">
  <p-steps [model]="process" [(activeIndex)]="activeIndex"></p-steps>
</div>
<div class="col-12">
  <div class="col-4 align-left">
  </div>
  <div class="col-4 align-center">
  </div>
  <div class="col-4 align-right">
    <button *ngIf="currentStep === 'REVIEW'" type="button" [icon]="'fa fa-check'" class="p-button-warning"
            [iconPos]="'right'"
            [label]="'COMMON.VALIDATE' | translate" pButton (click)="saveExpressDeposit()"></button>
  </div>
</div>
<div class="col-12" *ngIf="currentStep === 'PARAMS'">
  <app-deposit-options [depositType]="DepositDepotExpressEnum.SPOOL" (moveNext)="nextStep()" (signatureChange)="setSignatureFile($event)"
                       (depositDirChange)="setDepositDir($event)"></app-deposit-options>
</div>
<div class="col-12" *ngIf="currentStep === 'TEMPLATE'">
  <div class="col-12 align-right">
    <button [disabled]="!nextEnabled()" type="button" [icon]="'fa fa-hand-o-right'"
            [label]="'COMMON.NEXT' | translate" pButton (click)="nextStep()"></button>
  </div>
  <div class="col-3">
    <div class="col-12">
      <app-files-upload
        filesTitle=""
        [moreThanOneFile]="false"
        [acceptedFiles]="['pdf']"
        [optional]="false"
        [shouldClearFiles]="shouldClearFiles"
        (isValid)="updateUploadValidity(FileStatus.MAIN, $event)"
        (selectedFiles)="setMainFile(FileStatus.MAIN, $event)">
      </app-files-upload>
    </div>
    <div *ngIf="mainFile !== null">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.SPLIT_OPTIONS' | translate">
        <div class="col-12">
          <div class="col-5">{{'UPLOAD_COMPONENT.EXPRESS_SPOOL_SPLIT_TYPE' | translate}}</div>
          <div class="col-7">
            <p-dropdown [options]="spoolSplitTypes" class="split-dropdown"
                        [(ngModel)]="selectedSpoolSplitType" (ngModelChange)="initSplitValue()"></p-dropdown>
          </div>
        </div>
        <div class="col-12" *ngIf="selectedSpoolSplitType === 'AREA'">
          <span>{{'UPLOAD_COMPONENT.EXPRESS_SPOOL_SPLIT_TYPE_AREA_HINT' | translate}}</span>
          <div class="col-5">
            {{'UPLOAD_COMPONENT.EXPRESS_SPOOL_SPLIT_TYPE_AREA_VALUE' | translate}}
          </div>
          <div class="col-2">
            <input pInputText type="number" [(ngModel)]="spoolNumberOfRecipients" (ngModelChange)="initAreaConfig()">
          </div>
        </div>
        <div class="col-12" *ngIf="selectedSpoolSplitType === 'PAGES'">
          <div class="col-5">
            {{'UPLOAD_COMPONENT.EXPRESS_SPOOL_SPLIT_TYPE_COUNT_VALUE' | translate}}
          </div>
          <div class="col-2">
            <input pInputText type="number" [(ngModel)]="spoolSplitEveryXPages" (ngModelChange)="onKeywordChange()">
          </div>
          <div class="col-5" *ngIf="spoolSplitEveryXPages">Page{{spoolSplitEveryXPages > 1 ? 's' : ''}}</div>
        </div>
        <div class="col-12" *ngIf="selectedSpoolSplitType === 'WORD'">
          <div class="col-5">
            {{'UPLOAD_COMPONENT.EXPRESS_SPOOL_SPLIT_TYPE_KEYWORD_VALUE' | translate}}
          </div>
          <div class="col-5">
            <input pInputText type="text" [(ngModel)]="spoolSplitKeyWord" (ngModelChange)="onKeywordChange()">
          </div>
          <div class="col-2"></div>
        </div>
        <div class="col-12" *ngIf="selectedSpoolSplitType === 'REGEX'">
          <div class="col-4">
            {{'UPLOAD_COMPONENT.EXPRESS_SPOOL_SPLIT_TYPE_REGEX_FILE_VALUE' | translate}}
          </div>
          <div class="col-8 ">
            <p-dropdown class="split-dropdown" id="cut-parameters"
                        [filter]="true"
                        optionLabel="name"
                        [options]="spools"
                        [(ngModel)]="selectedSpool"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="31"
                        (onChange)="selectSpool()"
                        (ngModelChange)="updateSelectedSpool($event)"
                        [ngClass]="{'spool-invalid': !spoolFileValidity , 'spool-valid': spoolFileValidity}"></p-dropdown>
          </div>
        </div>
        <div class="col-12 align-right" *ngIf="validSplitOptions()">
          <button type="button" class="p-button-warning"
                  [label]="'UPLOAD_COMPONENT.SPLIT_BTN_CAPTION' | translate" pButton
                  (click)="storeSpoolSplitInfo()"></button>
        </div>
      </p-fieldset>
    </div>
    <div *ngIf="validSplitOptions() && spoolData && spoolData.length > 0
                && spoolDataUnknownRows !== null && spoolDataUnknownRows !== 0">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.SPLIT_ERROR_MESSAGE' | translate">
        <div class="col-12 error-message">
          {{ 'UPLOAD_COMPONENT.SPLIT_ERROR_MESSAGE_INFO' | translate }}
        </div>
      </p-fieldset>
    </div>
  </div>
  <div class="col-9">
    <div class="col-6" *ngIf="validSplitOptions()">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.ADDRESS_DOC_CAPTURE' | translate"
                  *ngIf="pagesImages && pagesImages.hasOwnProperty('page_1')">
        <div class="col-12" *ngIf="pageCount > 1">
          <p-paginator [rows]="1" [totalRecords]="pageCount" (onPageChange)="updateBG($event)"
                       [showCurrentPageReport]="true"
                       [currentPageReportTemplate]="'Page:  {currentPage} sur {totalPages}'"></p-paginator>
        </div>
        <div class="col-12">
          <div class="extract-region-container" #addressDragContainer>
            <div class="extract-region-bg" [ngStyle]="containerBGStyle">
              <!--<div class="omr left-omr"></div>
              <div class="omr right-omr"></div>-->
              <div *ngIf="targetContainerStyle" class="extract-region-rect" #addressTargetContainer
                   [ngStyle]="targetContainerStyle"
                   [ngResizable]="true"
                   [ngDraggable]="true"
                   [rzHandles]="'n,e,s,w,se,sw,ne,nw'"
                   (endOffset)="recalculateRegion()"
                   (rzStop)="recalculateRegion()"
                   [bounds]="addressDragContainer"
                   rzContainment="#addressDragContainer"
                   [inBounds]="true"
              ></div>
            </div>
          </div>
        </div>
      </p-fieldset>
    </div>
    <div class="col-6" *ngIf="validSplitOptions() && spoolData && spoolData.length > 0">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.DATA_FILE_PREVIEW' | translate"
                  *ngIf="pagesImages && pagesImages.hasOwnProperty('page_1')">
        <div class="col-12">
          <div class="col-3">
            <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_COUNT' | translate}}:</div>
            <div class="col-2"> {{spoolData.length}}</div>
          </div>
          <div class="col-3">
            <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_VALID' | translate}}:</div>
            <div class="col-2"> {{spoolDataValidRows}}</div>
          </div>
          <div class="col-3">
            <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_INVALID' | translate}}:</div>
            <div class="col-2"> {{spoolDataInValidRows}}</div>
          </div>
          <div class="col-3" *ngIf="selectedSpoolSplitType === 'AREA'">
            <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_NOT_FOUND' | translate}}:</div>
            <div class="col-2"> {{spoolDataUnknownRows}}</div>
          </div>
          <div class="col-3" *ngIf="spoolData.length >0 && spoolDataInValidRows > 0">
            <button pButton type="button" [label]="'UPLOAD_COMPONENT.DELETE_INVALID_ROWS_LABEL' | translate"
                    class="p-button-success"
                    (click)="removeInvalidMailingRows()"
                    [pTooltip]="'UPLOAD_COMPONENT.DELETE_INVALID_ROWS_TOOLTIP' | translate"></button>
          </div>
        </div>
        <div class="col-12">
          <p-table *ngIf="spoolData" [value]="spoolData" selectionMode="single"
                   [scrollable]="true" scrollHeight="540px" dataKey="id">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 4em"></th>
                <th style="width: 4em">{{'UPLOAD_COMPONENT.MAILING_FIELDS.VALIDITY' | translate}}</th>
                <th>{{'UPLOAD_COMPONENT.SPOOL_FIELDS.POSTAL_ADDRESS' | translate}}</th>
                <th style="width: 4em">{{'UPLOAD_COMPONENT.SPOOL_FIELDS.PAGE_COUNT' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
              <tr [ngClass]="rowData.isValid() ? null : 'invalid-address'">
                <td style="width: 4em">{{rowIndex + 1}}</td>
                <td style="width: 4em">
                  <span *ngIf="rowData.isValid()">valide</span>
                  <span *ngIf="!rowData.isValid()" (click)="editMailingAddress(rowData, rowIndex)">Corriger</span>
                </td>
                <td>{{formatAddress(rowData)}}</td>
                <td style="width: 4em">{{rowData.pageCount}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-fieldset>
    </div>
  </div>
</div>
<div class="col-12" *ngIf="currentStep === 'FORMATTING'">
  <app-signature-options [signature]="signature" [depositDir]="depositDir" [pagesImages]="pagesImages" [pageCount]="pageCount" [pages]="pages"
                         [sigPages]="sigPages" (stored)="signaturePositionStored($event)"></app-signature-options>
</div>
<div class="col-12" *ngIf="currentStep === 'REVIEW'">
  <app-deposit-review type="SPOOL" [depositDir]="depositDir" [customizedFilePdf]="customizedFilePdf" [foldCount]="foldCount"></app-deposit-review>
<!--  <div class="col-3">
    <div class="col-12">
      <button type="button" [icon]="'fa fa-search'"
              [label]="'UPLOAD_COMPONENT.DOWNLOAD_FINAL' | translate" pButton
              (click)="loadVisualization(true)"></button>
    </div>
  </div>
  <div class="col-6 viewer-container">
    <div class="col-12">
      <p-paginator [rows]="1" [totalRecords]="foldCount" showCurrentPageReport="true"
                   [currentPageReportTemplate]="'Pli:  {currentPage} sur {totalPages}'"
                   (onPageChange)="prepareSpoolFinalFile($event)">
      </p-paginator>
    </div>
    <object *ngIf="pdfToDisplay && !msBrowsers" [data]="pdfToDisplay + '#view=FitH&zoom=100' | safeObjUrl"
            type="application/pdf" width="100%"
            height="100%"></object>
  </div>
  <div class="col-3"></div>-->
</div>
<div class="saving-loader-modal">
  <p-dialog [appendTo]="'body'" [(visible)]="displayLoading" [header]="'UPLOAD_COMPONENT.LOADER_TITLE' | translate"
            id="ex-save-loader" [draggable]="false" [closable]="false" [resizable]="false"
            [modal]="true" [closeOnEscape]="false">
    <div class="center">
      <div class="col-12" *ngIf="savingTrial && savingTrial > 1">
        <p>{{'UPLOAD_COMPONENT.SAVE_DEPOSIT_TRIAL' | translate}}: {{savingTrial}}</p>
      </div>
      <p *ngIf="depositPersistedSerialLot">{{'UPLOAD_COMPONENT.STATUS_SERIAL_DEPOSIT' | translate}}
        : {{depositPersistedSerialLot}}</p>
      <p-progressBar [value]="progressPersisted"></p-progressBar>
      <div class="col-12" *ngIf="depositPersistedSerialLot">
        <button pButton type="button" (click)="closeLoader()" [label]="'COMMON.CLOSE' | translate"
                class="p-button-danger"></button>
      </div>
      <p></p>
      <p>{{'UPLOAD_COMPONENT.LOADER_HINT' | translate}}</p>
    </div>
  </p-dialog>
</div>
<div *ngIf="showEditSpoolAddress">
  <p-dialog [styleClass]="'express-address-dialog'" [appendTo]="'body'" [(visible)]="showEditSpoolAddress"
            [header]="'Je modifie l\'adresse du courrier sélectionné'"
            [draggable]="true"
            [closable]="true"
            [maximizable]="true"
            [modal]="true" [closeOnEscape]="true">
    <app-express-address (finalAddress)="updateSpoolAddress($event)"
                         (visible)="handleDestAddressClose($event)"
                         [objAddress]="selectedSpoolAddress"
                         [lines]="selectedSpoolAddressLines"></app-express-address>
    <!-- <a href="pdfToDisplay">Download PDF</a>-->
  </p-dialog>
</div>
<div *ngIf="openVisualization">
  <p-dialog [styleClass]="'file-display-dialog'" [appendTo]="'body'" [(visible)]="openVisualization"
            [header]="'Je vérifie mon courrier avant de le soumettre '" (onHide)="freeDocMemory(pdfToDisplay)"
            [draggable]="true"
            [closable]="true"
            [maximizable]="true"
            [modal]="true" [closeOnEscape]="true">
    <object *ngIf="pdfToDisplay && !msBrowsers" [data]="pdfToDisplay + '#view=FitH&zoom=100' | safeObjUrl"
            type="application/pdf" width="100%"
            height="100%"></object>
    <!-- <a href="pdfToDisplay">Download PDF</a>-->
  </p-dialog>
</div>
